<template lang="pug">
#dados-area-monitorada
    .row
        .col-6
            item-informacoes(
                icon-class='mdi mdi-account',
                title='Contato',
                :value='this.areaMonitorada.dadosAreaMonitorada.nomeProprietario || " - "',
                :small='true',
                justify='flex-start',
                v-if='this.areaMonitorada.dadosAreaMonitorada'
            )
            item-informacoes(
                icon-class='mdi mdi-account-box-outline',
                title='Documento',
                :value='this.areaMonitorada.dadosAreaMonitorada.cpfCnpj || " - "',
                :small='true',
                justify='flex-start',
                v-if='this.areaMonitorada.dadosAreaMonitorada'
            )
            item-informacoes(
                icon-class='mdi mdi-vector-polygon',
                title='Propriedade/território',
                :value='this.areaMonitorada.dadosAreaMonitorada.nomeFazenda || " - "',
                :small='true',
                justify='flex-start',
                v-if='this.areaMonitorada.dadosAreaMonitorada'
            )
            item-informacoes(
                icon-class='flow flow-satellite',
                title='Área monitorada',
                :value='`${formatNumber(this.areaMonitorada.areaHa)} ha`',
                :small='true',
                justify='flex-start'
            )

        .col-6
            item-informacoes(
                :icon-class='getCulturaIcon(this.areaMonitorada.culturaEsperada.codigo)',
                title='Cultura informada',
                :value='this.areaMonitorada.culturaEsperada.nome',
                :small='true',
                justify='flex-start'
            )
            item-informacoes(
                icon-class='flow flow-square',
                title='Área plantada informada',
                :value='`${formatNumber(this.areaMonitorada.areaPlantadaEsperadaHa)} ha`',
                :small='true',
                justify='flex-start'
            )
            item-informacoes(
                icon-class='flow flow-wheat',
                title='Produtividade informada',
                :value='`${formatNumber(this.areaMonitorada.produtividadeEsperadaScHa)} sc/ha`',
                :small='true',
                justify='flex-start'
            )

            item-informacoes(
                icon-class='flow flow-stack',
                title='Volume informado',
                :value='volumeInformado',
                :small='true',
                justify='flex-start'
            )
</template>

<script>
import { CULTURA_ICONS } from '../../utils/helpers/icon-mapper';
import ItemInformacoes from '../quantitativos/ItemInformacoes';

import formatters from '@/utils/formatters';

export default {
    name: 'DadosAreaMonitorada',

    components: { ItemInformacoes },

    props: {
        areaMonitorada: {
            type: Object,
            required: true
        }
    },

    methods: {
        getCulturaIcon(codigoCultura) {
            if (!codigoCultura) return CULTURA_ICONS['null'];

            return CULTURA_ICONS[codigoCultura];
        },
        formatNumber(number) {
            return formatters.formatNumber(number, 2);
        }
    },
    computed: {
        volumeInformado() {
            const volume =
                this.areaMonitorada.areaPlantadaEsperadaHa *
                this.areaMonitorada.produtividadeEsperadaScHa *
                60;
            return formatters.formatNumber(volume) + ' kg';
        }
    }
};
</script>

<style scoped lang="scss">
#dados-area-monitorada {
    padding: 30px 20px 10px 20px;

    .informacoes-gerais {
        height: 40px;
    }

    .title {
        margin-bottom: 10px;
        font-weight: map-get($font-weight, medium);
    }

    .detalhes {
        color: var(--primary);
        cursor: pointer;
        margin-left: 30px;
    }
}
</style>
